module.exports = function() {
  return new Worker(__webpack_public_path__ + "0d55b351198a243a5a46.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js!./node_modules/.store/pdfjs-dist@2.6.347/node_modules/pdfjs-dist/es5/build/pdf.worker.js
// module id = HyoJ
// module chunks = 0